import React from 'react';
import * as S from './DesktopHeaderCategories.styles';
import { DesktopHeaderCategoriesProps } from './DesktopHeaderCategories.types';
import { useDesktopCatalogueStore } from '@/store/useDesktopCatalogueStore';
import { CustomLink } from '@/components/CustomLink/CustomLink';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';
import { DEFAULT_CATEGORIES_COUNT } from '@/components/Header/components/DesktopHeaderCatalogue.constants';

export const DesktopHeaderCategories = ({
  items,
  selectedItemId,
  onSelect,
  onColumnLeave,
  isFirstColumn,
  loading,
}: DesktopHeaderCategoriesProps) => {
  const [toggleDesktopCatalogue] = useDesktopCatalogueStore(state => [
    state.toggleDesktopCatalogue,
  ]);

  if (loading) {
    return (
      <S.DesktopHeaderCategoryItems $isFirstColumn={isFirstColumn}>
        {Array.from({ length: DEFAULT_CATEGORIES_COUNT }, (_, index) => (
          <S.DesktopHeaderCategorySkeletonItem key={index}>
            <SkeletonLoader borderRadius={7} width={30} height={30} />
            <SkeletonLoader borderRadius={4} width={200} height={18} />
          </S.DesktopHeaderCategorySkeletonItem>
        ))}
      </S.DesktopHeaderCategoryItems>
    );
  }

  return (
    <S.DesktopHeaderCategoryItems
      $isFirstColumn={isFirstColumn}
      onMouseLeave={onColumnLeave}
    >
      {items.map(({ id, path, name, hasDecendants, iconSrc }) => (
        <S.DesktopHeaderCategoryItem
          key={id}
          as={CustomLink}
          href={path}
          onClick={toggleDesktopCatalogue}
          $isSelected={selectedItemId === id}
          onMouseEnter={() => onSelect(id)}
        >
          {iconSrc && <S.DesktopHeaderCategoryIcon $src={iconSrc} />}
          <S.DesktopHeaderCategoryLabel $isFirstColumn={isFirstColumn}>
            {name}
          </S.DesktopHeaderCategoryLabel>
          {hasDecendants && (
            <S.DesktopHeaderCategoryAngleIcon $isFirstColumn={isFirstColumn} />
          )}
        </S.DesktopHeaderCategoryItem>
      ))}
    </S.DesktopHeaderCategoryItems>
  );
};
